'use client';

import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { cn } from '@/app/utils';
import { useRouter } from '@/i18n/routing';
import { reportProductPageElementClick } from '../utils';

interface FreeToCreateButtonProps {
  disabled?: boolean;
  targetRoute: string;
  className?: string;
  children?: ReactNode;
  buttonText?: string;
  /** 点击提交后、跳转前执行（可用于先同步表单再跳转） */
  onBeforeNavigate?: () => void | Promise<void>;
}

export const FreeToCreateButton: React.FC<FreeToCreateButtonProps> = ({
  disabled = false,
  targetRoute,
  className,
  children,
  buttonText,
  onBeforeNavigate,
}) => {
  const t = useTranslations();
  const router = useRouter();
  const handleSubmit = async () => {
    if (disabled) {
      return;
    }
    reportProductPageElementClick('Free to create');

    if (onBeforeNavigate) {
      await onBeforeNavigate();
    }

    router.push(targetRoute);
  };

  return (
    <div className={cn('mt-4 flex w-full items-center justify-end gap-4', className)}>
      {children}
      <button
        type="button"
        className={cn(
          '!rounded-10 h-8 min-w-[132px] cursor-pointer bg-gradient-to-r from-[#3CA3FF] to-[#0086FF_73.4%] font-semibold text-sm text-white',
          disabled && 'cursor-not-allowed opacity-20',
        )}
        onClick={handleSubmit}
        disabled={disabled}
      >
        {buttonText ?? t('create.createForm.productPageSubmit')}
      </button>
    </div>
  );
};
